<template>
  <div id="password-reset">
    <Form
      :header="header"
      :model="model"
      :schema="schema"
      :options="options"
      :buttons="buttons"
      :messages="messages"
      @form_submit="form_submit"
    ></Form>
  </div>
</template>

<script>
import Vue from "vue";
import Form from "../../components/Form.vue";
import VueFormGenerator from "vue-form-generator";
import { get_validator_messages } from "../../validators/locale_pl";

var validator_messages = get_validator_messages();

export default {
  name: "PasswordReset",
  components: {
    Form
  },
  data() {
    return {
      buttons: [
        {
          name: "password-reset",
          style_classes: "float-right mb-1",
          buttons: [
            {
              label: "Zresetuj",
              variant: "success",
              type: "submit",
              name: "password-reset",
              icon: "lock-fill"
            }
          ]
        }
      ],
      header: {
        title: "Reset hasła",
        icon: "lock-fill"
      },
      messages: [
        {
          label:
            "Na podany adres email wyślemy kod niezbędny do zresetowania hasła.",
          variant: "info"
        }
      ],
      model: {
        email: null
      },
      schema: {
        groups: [
          {
            styleClasses: "form-row",
            fields: [
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "email",
                label: "Email",
                model: "email",
                required: true,
                validator: [
                  VueFormGenerator.validators.email.locale(validator_messages)
                ]
              }
            ]
          }
        ]
      },
      options: {
        validateAfterChanged: true,
        validateAsync: true
      }
    };
  },
  methods: {
    form_submit: function(model) {
      Vue.CognitoAuth.forgot_password(
        {
          username: model.email
        },
        this.password_reset_success,
        this.password_reset_failure
      );
    },
    password_reset_success: function() {
      this.$localStorage.set("password_reset_email", this.model.email);
      this.$router.push({ name: "PasswordResetConfirm" });
    },
    password_reset_failure: function() {
      this.messages = [];
      this.messages = [
        {
          label:
            "Jeżeli podałeś poprawny adres email, otrzymasz kod niezbędny do zmiany hasła.",
          variant: "info"
        }
      ];
    }
  }
};
</script>

<style>
@media (min-width: 768px) {
  #password-reset .form-container {
    max-width: 520px;
  }
}
</style>
